import {NEW_PROPOSAL as ActionTypes} from '../actionTypes';

const initialState = {
    proposal: {
        proposalId: '',
        batchId: 0,
        statusId: 1,
        statusDisplay: 'Sent',
        agentId: 0,
        agentName: '',
        agentLastName: '',
        agentEmail: '',
        dobNowEmail: '',
        auditDobNowEmail: '',
        customerId: 0,
        customerName: '',
        agreedToTermsAndConditions: '',
        year: '',
        superName: '',
        auditSuperName: '',
        dateCreated: '',
        isPeriodic: false,
        renewalCat1ElevatorFee: '0',
        canEdit: false,
    },
    proposalDetails: {
        proposalDetailId: 0,
        proposalId: '',
        batchId: 0,
        statusId: 0,
        statusDisplay: '',
        inspectionId: 0,
        inspectionLineId: 0,
        buildingId: 0,
        buildingAddress: '',
        corpName: '',
        auditCorpName: '',
        elevatorCompanyId: 0,
        elevatorCompany: '',
        auditElevatorCompany: '',
        trackAoc: false,
        auditTrackAoc: '',
        qce: false,
        auditQce: false,
        superName: '',
        auditSuperName: '',
        superPhone: '',
        auditSuperPhone: '',
        device: '',
        year: '',
        agentId: 0,
        agentEmail: '',
        dateCreated: '',
        isPeriodic: false,
        agreementThroughYear: 0
    },
    lines: [],
    underContractLines: [],
    expiringLines: [],
    elevatorCompanies: []
};

export const newProposalReducer = (state = initialState, action) => {
    switch (action.type) {
        case ActionTypes.SET_NEW_PROPOSAL_DETAIL:
            return {
                ...state,
                proposalDetails: action.payload
            };

        case ActionTypes.SET_NEW_PROPOSAL:
            return {
                ...state,
                proposal: action.payload.proposal,
                lines: action.payload.lines,
                expiringLines: action.payload.expiringLines,
                underContractLines: action.payload.underContractLines
            };
            
            // same as SET_NEW_PROPOSAL but in case it will change, this is needed to not break the data format needed on old pages (year<2025)
        case ActionTypes.SET_PROPOSAL_V2:
            return {
                ...state,
                proposal: action.payload.proposal,
                lines: action.payload.lines,
                expiringLines: action.payload.expiringLines,
                underContractLines: action.payload.underContractLines
            };
            
        case ActionTypes.SET_NEW_LINES:
            // used for approve all or reject all
            const currentYear2 = new Date().getFullYear();

            let expiringLines2 = action.payload.filter(f => f.agreementThroughYear <= currentYear2);
            let underContractLines2 = action.payload.filter(f => f.agreementThroughYear > currentYear2);

            return {
                ...state,
                lines: action.payload,
                expiringLines: expiringLines2,
                underContractLines: underContractLines2
            };

        case ActionTypes.UPDATE_BUILDING: {
            let allLines = [...state.lines];
            let selectedBuildingId = allLines.findIndex(c => c.proposalDetailId === action.payload.proposalDetailId);

            allLines[selectedBuildingId] = {
                ...action.payload,
                devices: allLines[selectedBuildingId].devices.map((device) => {
                    return {
                        ...device,
                        auditElevatorCompany: action.payload.auditElevatorCompany,
                        elevatorCompanyId: action.payload.elevatorCompanyId, // TODO -> make sure this must be updated and if so update also the elevatorCompany
                        auditSuperName: action.payload.auditSuperName,
                        auditSuperPhone: action.payload.auditSuperPhone,
                    };
                })
            };
            
            const currentYear = new Date().getFullYear();
            let underContractLines = allLines.filter(f => f.agreementThroughYear > currentYear);
            let expiringLines = allLines.filter(f => f.agreementThroughYear <= currentYear);

            return {
                ...state,
                lines: allLines,
                expiringLines: expiringLines,
                underContractLines: underContractLines
            };
        }
        case ActionTypes.UPDATE_NEW_PROPOSAL:
            // used to update the status of the prop from sent to viewed and from viewed to submitted
            return {
                ...state,
                proposal: action.payload
            };

        case ActionTypes.UPDATE_OPTIONAL_SERVICES: {
            const {buildingIds, agreedToExpeditingFee, aocTracking, qce, qceFrequency, areUnderContractBuildings} = action.payload;
            const updateOptionalServices = (item) => {
                const getUpdatedValue = (contractValue, newValue) => 
                    !areUnderContractBuildings ? newValue : contractValue || newValue;
                    
                const getUpdatedFrequency = (item) =>
                    !areUnderContractBuildings ? qceFrequency :
                        (item.qceFrequency < qceFrequency ? qceFrequency : (item.qce ? item.qceFrequency : qceFrequency));
                
                return {
                    auditAgreedToExpeditingFee: getUpdatedValue(item.agreedToExpeditingFee, agreedToExpeditingFee),
                    auditTrackAoc: getUpdatedValue(item.trackAoc, aocTracking),
                    auditQce: getUpdatedValue(item.qce, qce),
                    auditQceFrequency: getUpdatedFrequency(item)
                };
            };
            
            const lines = state.lines.map(item =>
                buildingIds.includes(item.buildingId)
                    ? {
                        ...item,
                        ...updateOptionalServices(item),
                        devices: item.devices.map(device => ({
                            ...device,
                            ...updateOptionalServices(device)
                        }))
                      }
                    : item
            );

            const currentYear = new Date().getFullYear();
            const expiringLines = lines.filter(f => f.agreementThroughYear <= currentYear);
            const underContractLines = lines.filter(f => f.agreementThroughYear > currentYear);

            return {
                ...state,
                lines,
                underContractLines,
                expiringLines
            };
        }
        case ActionTypes.SET_ELEVATOR_COMPANIES:
            return {
                ...state,
                elevatorCompanies: action.payload
            };
        case ActionTypes.UPDATE_DEVICE_ELEVATOR_COMPANY: {
            const {
                buildingId,
                device,
                elevatorCompanyId,
                auditElevatorCompany,
                auditSuperName, 
                auditSuperPhone
            } = action.payload;

            const lines = state.lines.map((building) => {
                if (building.buildingId !== buildingId) return building;

                const updatedDevices = building.devices.map((deviceProposal) =>
                    deviceProposal.device === device
                        ? {...deviceProposal, elevatorCompanyId, auditElevatorCompany, auditSuperName, auditSuperPhone}
                        : deviceProposal
                );

                const updateBuildingElevatorCompany =
                    updatedDevices.length === 1 || updatedDevices.every(d => d.elevatorCompanyId === elevatorCompanyId);

                return {
                    ...building,
                    devices: updatedDevices,
                    elevatorCompanyId: updateBuildingElevatorCompany
                        ? elevatorCompanyId
                        : building.elevatorCompanyId,
                    auditElevatorCompany: updateBuildingElevatorCompany
                        ? auditElevatorCompany
                        : building.auditElevatorCompany
                };
            });

            const currentYear = new Date().getFullYear();
            const expiringLines = lines.filter(f => f.agreementThroughYear <= currentYear);
            const underContractLines = lines.filter(f => f.agreementThroughYear > currentYear);

            return {
                ...state,
                lines,
                underContractLines,
                expiringLines
            };
        }
        default:
            return state;
    }
}